function toggleMenu() {
  const menu = document.querySelector("#menu");
  const menuFooter = document.querySelector("#menu-footer");

  menu.classList.toggle("hidden");
  menuFooter.classList.toggle("hidden");

  menu.classList.toggle("flex");
  menuFooter.classList.toggle("block");
}

function handleClickOutside(event) {
  const menu = document.querySelector("#menu");
  const menuUl = menu.querySelector("ul");
  const menuFooter = document.querySelector("#menu-footer");

  if (
    !menuUl.contains(event.target) &&
    !menuFooter.contains(event.target) &&
    !document.querySelector("#menu-action").contains(event.target)
  ) {
    menu.classList.add("hidden");
    menuFooter.classList.add("hidden");

    menu.classList.remove("flex");
    menuFooter.classList.remove("block");
  }
}

document
  .querySelector("#menu-action")
  .addEventListener("click", function (event) {
    event.stopPropagation();
    toggleMenu();
  });

document.addEventListener("click", handleClickOutside);

const headerSlider = () => {
  console.log("Header logic is rendering");
  let lastScrollTop = 0;
  const header = document.querySelector("header");

  window.addEventListener("scroll", () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScrollTop && scrollTop > 40) {
      // Downscroll
      header.classList.add("header-hide");
    } else {
      // Upscroll
      header.classList.remove("header-hide");
    }

    lastScrollTop = scrollTop;
  });
};

document.addEventListener("DOMContentLoaded", function () {
  // Retrieve the primary color from Liquid
  let primaryColor = "{{ primary_color }}";

  // Check if a saved primary color exists in local storage
  const savedPrimaryColor = localStorage.getItem("primary_color");

  if (savedPrimaryColor) {
    // Use the saved primary color
    primaryColor = savedPrimaryColor;
  } else {
    // Save the current primary color in local storage
    localStorage.setItem("primary_color", primaryColor);
  }

  // Apply the primary color to the website
  if (document.body.classList.contains("template--index")) {
    document.documentElement.style.setProperty("--color-primary", primaryColor);
  }

  headerSlider();
});

let scrollPos = 0;

class VideoOnScroll extends HTMLElement {
  constructor() {
    super();
    if (
      window.innerWidth < 769 &&
      this.closest("div").dataset.removeSection == "mobile"
    ) {
      this.closest("div").remove();
      return;
    } else if (
      window.innerWidth > 768 &&
      this.closest("div").dataset.removeSection == "desktop"
    ) {
      this.closest("div").remove();
      return;
    } else if (
      window.innerWidth < 769 &&
      this.dataset.removeSection == "mobile"
    ) {
      this.remove();
    } else if (
      window.innerWidth > 768 &&
      this.dataset.removeSection == "desktop"
    ) {
      this.remove();
      return;
    }
    let config = {
      scrollyVideoContainer: this.querySelector("div"),
      src: this.dataset.url,
      useWebCodecs: false,
    };
    if (this.classList.contains("product-video")) {
      this.hasRunnedLow = false;
      this.hasRunnedMid = false;
      this.hasRunnedHigh = false;
      this.currentEl = 0;
      this.isGoingUp = false;
      config.onChange = (el) => {
        const slide1 = document.querySelector(".ft-1");
        const slide2 = document.querySelector(".ft-2");
        const slide3 = document.querySelector(".ft-3");
        this.isGoingUp = this.currentEl - el > 0;
        this.currentEl = el;
        if (el > 0.67 && el <= 0.82) {
          slide1.style.marginTop = "-160vh";
          if (!this.hasRunnedHigh && !this.isGoingUp) {
            this.hasRunnedHigh = true;
            this.hasRunnedLow = false;
            this.hasRunnedMid = false;
            this.scrollToEl(0.82, "high");
          }
        } else if (el > 0.23 && el <= 0.66) {
          slide1.style.marginTop = "-80vh";
          if (!this.hasRunnedMid && !this.isGoingUp) {
            this.hasRunnedMid = true;
            this.scrollToEl(0.66, "mid");
            this.hasRunnedHigh = false;
            this.hasRunnedLow = false;
          }
        } else if (el > 0 && el <= 0.22) {
          slide1.style.marginTop = "-0px";
          if (!this.hasRunnedLow && !this.isGoingUp) {
            this.hasRunnedLow = true;
            this.hasRunnedHigh = false;
            this.hasRunnedMid = false;
            this.scrollToEl(0.22, "low");
          }
        }
        if (el > 0.89) {
          this.style.opacity = (1 - el) * 10;
          this.hasRunnedLow = false;
          this.hasRunnedHigh = false;
          this.hasRunnedMid = false;
        }
      };
    }
    const scrollVideo = new ScrollyVideo(config);
    scrollVideo.onChange((el) => {
      console.log(el);
    });
  }
  scrollToEl(targetEl, label) {
    const scrollInterval = setInterval(() => {
      window.scrollBy(0, 2);

      console.log(
        `${label} => currentEl ${this.currentEl} - ${targetEl} = ${
          this.currentEl - targetEl
        }`
      );
      if (this.currentEl >= targetEl) {
        clearInterval(scrollInterval);
      }
    }, 5);
  }
}

customElements.define("video-on-scroll", VideoOnScroll);

function playVideosInViewport() {
  const videos = document.querySelectorAll(".play-on-viewport");

  if ("IntersectionObserver" in window) {
    const observerOptions = {
      threshold: 0.4, // 40% of the video needs to be in the viewport
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.4) {
          entry.target.play();
          observer.unobserve(entry.target); // Optionally unobserve to avoid repeated checks
        } else {
          entry.target.pause();
        }
      });
    }, observerOptions);

    videos.forEach((video) => {
      observer.observe(video);
    });
  } else {
    const checkViewport = () => {
      videos.forEach((video) => {
        const rect = video.getBoundingClientRect();
        const viewportHeight =
          window.innerHeight || document.documentElement.clientHeight;
        const viewportWidth =
          window.innerWidth || document.documentElement.clientWidth;

        const inViewportHeight = Math.max(
          0,
          Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0)
        );
        const inViewportWidth = Math.max(
          0,
          Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0)
        );
        const inViewportArea = inViewportHeight * inViewportWidth;
        const videoArea = rect.height * rect.width;

        const isInViewport = inViewportArea / videoArea >= 0.4;

        if (isInViewport) {
          video.play();
        } else {
          video.pause();
        }
      });
    };

    window.addEventListener("scroll", checkViewport);
    window.addEventListener("resize", checkViewport);
    checkViewport();
  }
}

// Usage example
document.addEventListener("DOMContentLoaded", () => {
  playVideosInViewport();
});

document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll("section");
  let scrollElements;
  let isScrolling = false;

  function determineScrollElements() {
    if (window.innerWidth < 769) {
      scrollElements = document.querySelectorAll(".scroll-to-target--mobile");
    } else {
      scrollElements = document.querySelectorAll(".scroll-to-target--pc");
    }
  }

  function smoothScrollTo(y) {
    window.scrollTo({
      top: y,
      behavior: "smooth",
    });
  }

  function handleScroll(event) {
    if (isScrolling) {
      event.preventDefault();
      return;
    }

    const currentScroll = window.scrollY;
    let currentIndex = -1;

    scrollElements.forEach((section, index) => {
      if (section.offsetTop <= currentScroll + window.innerHeight / 2) {
        currentIndex = index;
      }
    });

    const nextSection = scrollElements[currentIndex + 1];
    const prevSection = scrollElements[currentIndex - 1];

    if (
      event.deltaY > 0 &&
      nextSection &&
      nextSection.offsetTop - currentScroll <= window.innerHeight * 1.5
    ) {
      // Scrolling down
      isScrolling = true;
      smoothScrollTo(nextSection.offsetTop);
      setTimeout(() => {
        isScrolling = false;
      }, 1000);
      event.preventDefault();
    } else if (
      event.deltaY < 0 &&
      prevSection &&
      currentScroll - prevSection.offsetTop <= window.innerHeight * 1.5
    ) {
      // Scrolling up
      isScrolling = true;
      smoothScrollTo(prevSection.offsetTop);
      setTimeout(() => {
        isScrolling = false;
      }, 1000);
      event.preventDefault();
    }
  }

  window.addEventListener("resize", determineScrollElements);
  window.addEventListener("wheel", handleScroll, { passive: false });
  determineScrollElements();
});
